export default "__VITE_ASSET__8ccb9c6a__"